import React, { Component } from "react";
import { Drawer, Card, Tooltip, Button, notification, Select, Checkbox, Row, Form, Col, DatePicker } from "antd";
import { TableComp } from "sz-react-utils";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { connect } from "react-redux";
import Request, { API_URL } from "../../request";
import moment from "moment";
import _ from 'lodash';
import async from 'async'
import LatestFollowup from "../../components/_utils/latestFollowup";
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { T } from "antd/lib/upload/utils";

let userCheckBox = {}
let userData = []
const Option = Select.Option;
const { RangePicker } = DatePicker
const dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY'
const typeData = {
    "rawInquiry":'Raw Inquiry',
    "inquiry":'Inquiry'
}

@Form.create()
class SendThankyouMessage extends Component {
    state = {
        visible: true,
        templateArr: []
    }

    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }


    async componentDidMount() {
        let response = await Request.getTemplatesForCommunication('Whatsapp');
        let templateArr = []
        async.each(response, (template) => {
            templateArr.push({ _id: template._id, display: template.templateName })
        })
        this.setState({ templateArr })
    }

    handleSubmit = (e) => {
        let { form, userArr } = this.props
        e.preventDefault();
        form.validateFieldsAndScroll(async(err, valData) => {
            let values = _.clone(valData)
            values.userArr = userArr
            let response = await Request.sendThankyouToConncetedCalls(values);
            if(response.success) {
                notification.success({
                    message:response.message
                })
            }else {
                notification.error({
                    message:response.message
                })
            }
            this.onClose()
        })
    }

    render() {
        let { visible, templateArr } = this.state
        let { form: { setFieldsValue, getFieldDecorator }, userArr } = this.props;
        let inputTypes = {
            fields: [
                {
                    label: 'Select Template',
                    key: 'templateId',
                    type: 'select',
                    required: true,
                    options: templateArr,
                    onChange: v => {
                        setFieldsValue({ templateId: v })
                    }
                }
            ]
        }
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Send WhatsApp Message
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={600}
                visible={visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputTypes} apiurl={API_URL} getFieldDecorator={getFieldDecorator} />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.state.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}


class CallDetailsRecord extends Component {
    state = {
        visible: true,
        count: 0,
        callUsers: [],
        userCheckBox: {},
        showWhatsappMessageDrawer: false,
        userArr: []
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            let { record, status, callDate, stage, whatsappSent } = this.props
            params.callerId = record._id;
            params.sortField = "callDate";
            params.sortOrder = "ASC"

            if (status !== null) {
                params.callStatus = status
            }
            if (stage !== null) {
                params.stage = stage
            }
            if (whatsappSent !== null) {
                params.sendWhatsappMessage = whatsappSent
            }
            params.callDate = callDate
            let response = await Request.getCallDetailsByCaller(params);
            async.each(response.data, (item) => {
                if (!userCheckBox[item._id]) {
                    userCheckBox[item._id] = {
                        _id: item._id,
                        id: item.id,
                        studentId: item.studentId,
                        callStatus: item.callStatus,
                        businessId: item.businessId,
                        studentName: item.studentName,
                        type:item.type,
                        isChecked: false
                    }
                }
            })
            this.setState({ count: response.total, userCheckBox: userCheckBox })
            resolve(response)
        })
    }

    selectUser = (item, studentId) => {
        let cloneUserCheckBox = _.clone(this.state.userCheckBox)
        if (cloneUserCheckBox[studentId] === undefined) {
            cloneUserCheckBox[studentId] = [];
        }
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked;
        this.setState({ userCheckBox: cloneUserCheckBox })
    }


    sendThankyouWhatsappMessages = () => {
        let userArr = _.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length > 0) {
            this.setState({ userArr, showWhatsappMessageDrawer: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }

    closeMessageDrawer = () => {
        userCheckBox = {}
        this.setState({ showWhatsappMessageDrawer: false, userArr: {}, userCheckBox: {} }, () => {
            this.table.current.reload()
        })
    }


    onClose = () => {
        this.setState({ visible: false })
        setTimeout(() => {
            this.props.onClose()
        })
    }
    render() {
        let { visible, count, showWhatsappMessageDrawer, userArr } = this.state;
        let { status } = this.props
        let columns = [
            {
                title: 'Sr No.',
                key: 'serialNumber',
                width: 80,
                render: (text, record, index) => (
                    <span>{index + 1}</span>
                )
            },
            {
                title: 'Action',
                key: 'operation',
                width: 100,
                render: (text, record) => (
                    <React.Fragment>
                        <Checkbox
                            checked={userCheckBox[record._id] ? userCheckBox[record._id].isChecked : false}
                            onChange={y => {
                                this.selectUser(y, record._id)
                            }}>
                        </Checkbox>
                    </React.Fragment>
                )
            },
            {
                title:'Type',
                key:'type',
                width:100,
                render:(text,record)=>(
                    <span>{typeData[text]}</span>
                )
            },
            {
                title: 'V.I.D',
                key: 'id',
                width: 80,
                filterRegex: true,
                searchTextName: "V.I.D"
            },
            {
                title: 'Student Name',
                key: 'studentName',
                filterRegex: true,
                searchTextName: "studentName"
            },
            {
                title: "Student Mobile",
                key: 'studentMobile',
                filterRegex: true,
                searchTextName: "studentMobile"
            },
            {
                title: 'Call Status',
                key: 'callStatus',
                filters: [{ text: "Connected", value: "Connected" }, { text: "Not Connected", value: "Not Connected" }],
                render: (text, record) => (
                    record.callStatus === "Not Connected" ? <div>
                        <div>{text}</div>
                        <small>{record.notConnectedReason}</small>
                    </div> : <div>{text}</div>
                )
            },
            {
                title: 'Stage',
                key: 'stage',
                filters: [{ text: "Open", value: "Open" }, { text: 'In Progress', value: "In Progress" }, { text: 'Converted', value: 'Converted' }, { text: 'Lost', value: 'Lost' }],
                render: (text, record) => (
                    record.stage === "Lost" ? <div>
                        <div>{text}</div>
                        <small>{record.lostReason}</small>
                    </div> : <div>{text}</div>
                )
            },
            {
                title: 'Call Done By',
                key: 'callerId',
                dataIndex: "callerId.name",
            },
            {
                title: 'Call Date',
                key: 'callDate',
                render: (text, record) => (
                    <span>{moment(record.callDate).format(dateFormat)}</span>
                )
            },
            {
                title: 'Call Time',
                key: 'callTime',
                render: (text, record) => (
                    <span>{moment(record.callDate).format("HH:mm A")}</span>
                )
            },
            {
                title:'Call Duration',
                key:'callDuration'
            },
            {
                title: 'Interested In',
                key: 'interestedIn',
                filterRegex: true,
                searchTextName: "interestedIn"
            },
            {
                title: "Follow Up",
                key: "followUp",
                width: 200,
                dataIndex: "followUp",
                render: (text, record) => {
                    return <LatestFollowup info={text} />;
                },
            },
            {
                title: 'Remark',
                key: 'remark'
            }
        ]
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Call Details - {count}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={1100}
                visible={visible}>
                <React.Fragment>
                    {
                        showWhatsappMessageDrawer ?
                            <SendThankyouMessage userArr={userArr} onClose={this.closeMessageDrawer} />
                            : null
                    }

                    <Card bordered={true}>
                        {
                            status === "Connected" ?
                                <Row>
                                    <Col span={6}>
                                        <Button type="primary" onClick={this.sendThankyouWhatsappMessages}>Send Thanks Message</Button>
                                    </Col>
                                </Row>
                                : null
                        }
                        <TableComp
                            id={"callReport"}
                            columns={columns}
                            ref={this.table}
                            useFixedHeader={true}
                            apiRequest={this.apiRequest}
                            extraProps={{ scroll: { x: 1600 } }}
                            pagination={{
                                showSizeChanger: true,
                                defaultPageSize: 20,
                                pageSizeOptions: ['10', '20', '50', '100', '1000']
                            }}
                        />
                    </Card>
                </React.Fragment>
            </Drawer>
        )
    }

}




class CallReport extends Component {
    state = {
        total: 0,
        showCallDrawer: false,
        record: {},
        stage: null,
        status: null,
        callUsers: [],
        callerId: null,
        whatsappSent: null,
        callDate: {
            from: moment().startOf('day').toDate(),
            to: moment().endOf('day').toDate()
        }
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }


    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            if (this.state.callerId && this.state.callerId !== null) {
                params.callerId = [this.state.callerId]
            }
            params.callDate = this.state.callDate;
            let response = await Request.getCallDetails(params);
            this.setState({ total: response.total });
            return resolve(response)
        })
    }


    reload = () => {
        this.table.current.reload()
    }

    componentDidMount() {
        Request.loadCallUsers().then((resp) => {
            let callUsers = []
            async.each(resp.data, (callUser) => {
                callUsers.push({ value: callUser._id, text: callUser.name })
            })
            this.setState({ callUsers })
        })
    }

    chooseRangerPicker = (date, dateString) => {
        this.state.showDate = true;

        this.setState(
            {
                callDate: {
                    from: date[0],
                    to: date[1],
                },
            },
            () => { }
        );
        setTimeout(() => {
            this.reload();
        }, 500);
    };

    showCallDetails = (data) => {
        this.setState({ record: data.record, status: data.status, stage: data.stage, whatsappSent: data.whatsappSent, showCallDrawer: true })
    }

    closeCallDetailRecord = () => {
        this.setState({ record: {}, status: null, showCallDrawer: false })
    }
    deleteCallDetail = async (recordId) => {
        let response = await Request.deleteCallRecord({ id: recordId });
        if (response.success) {
            notification.success({
                message: response.message
            })
        } else {
            notification.error({
                message: response.message
            })
        }
        this.reload()
    }


    render() {
        console.log(this.state)
        let { total, showCallDrawer, record, status, callUsers, stage, whatsappSent } = this.state;
        const columns = [
            {
                title: 'Sr. No',
                key: 'serialNumber',
                width: 60,
                dataIndex: 'serialNumber',
                fixed: 'left',
                render: (text, record, index) => (
                    <span>{index + 1}</span>
                )
            },
            {
                title: 'Caller Name',
                key: 'callerId',
                width: 180,
                fixed: 'left',
                dataIndex: 'callerName',
                filters: callUsers
            },
            {
                title: 'Call Attempted',
                key: 'totalCalls',
                render: (text, record) => (
                    <span><a onClick={() => this.showCallDetails({ record, status: null, stage: null, whatsappSent: null })}>{text}</a></span>
                )
            },
            {
                title: 'Calls Connected',
                key: 'connectedCalls',
                render: (text, record) => (
                    <span><a onClick={() => this.showCallDetails({ record, status: "Connected", stage: null, whatsappSent: null })}>{text}</a></span>
                )
            },
            {
                title: 'Calls Not Connected',
                key: 'notConnectedCalls',
                render: (text, record) => (
                    <span ><a onClick={() => this.showCallDetails({ record, status: 'Not Connected', stage: null, whatsappSent: null })}>{text}</a></span>
                )
            },
            {
                title: "Total Whatsapp Message",
                key: 'whatsappSent',
                render: (text, record) => (
                    <span ><a onClick={() => this.showCallDetails({ record, status: null, stage: null, whatsappSent: true })}>{text}</a></span>
                )
            },
            {
                title: 'Open',
                key: 'openStage',
                width:60,
                render: (text, record) => (
                    <span ><a onClick={() => this.showCallDetails({ record, stage: 'Open', status: null, whatsappSent: null })}>{text}</a></span>
                )
            },
            {
                title: 'In Progress',
                key: 'inProgressStage',
                width:120,
                render: (text, record) => (
                    <span ><a onClick={() => this.showCallDetails({ record, stage: 'In Progress', status: null, whatsappSent: null })}>{text}</a></span>
                )
            },
            {
                title: 'Converted',
                key: 'convertedStage',
                width:80,
                render: (text, record) => (
                    <span ><a onClick={() => this.showCallDetails({ record, stage: 'Converted', status: null, whatsappSent: null })}>{text}</a></span>
                )
            },
            {
                title: 'Lost',
                key: 'lostStage',
                width:60,
                render: (text, record) => (
                    <span ><a onClick={() => this.showCallDetails({ record, stage: 'Lost', status: null, whatsappSent: null })}>{text}</a></span>
                )
            },

        ]
        return (
            <PageHeaderWrapper title={`
                Calls Report : ${total}`}>
                {
                    showCallDrawer ?
                        <CallDetailsRecord callDate={this.state.callDate} record={record} stage={stage} status={status} whatsappSent={whatsappSent} onClose={this.closeCallDetailRecord} />
                        : null
                }
                <Card bordered={true}>
                    <Row>
                        <Col span={8}>
                            <h4>Search By User</h4>
                            <Select allowClear
                                showSearch={true}
                                style={{ width: '90%' }}
                                value={this.state.callerId}
                                placeholder="Select Option"
                                optionFilterProp="name"
                                onChange={callerId => {
                                    this.setState({ callerId }, () => {
                                        setTimeout(() => {
                                            this.reload()
                                        }, 200)
                                    })
                                }}>
                                {
                                    callUsers.map((callUser) => (
                                        <Option value={callUser.value}>{callUser.text}</Option>
                                    ))
                                }
                            </Select>
                        </Col>
                        <Col span={12}>
                            <h4>Filter By Date</h4>
                            <RangePicker
                                defaultValue={[moment(this.state.callDate.from), moment(this.state.callDate.to)]}
                                format="YYYY-MM-DD"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                    </Row>

                </Card>
                <Card bordered={true}>
                    <TableComp
                        id={"callReport"}
                        columns={columns}
                        ref={this.table}
                        useFixedHeader={true}
                        apiRequest={this.apiRequest}
                        // extraProps={{ scroll: { x: 1400 } }}
                        pagination={{
                            showSizeChanger: false,
                            defaultPageSize: 1200,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>
        )
    }
}




const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CallReport)